"use client";

import { Libraries, useJsApiLoader } from "@react-google-maps/api";
import { ReactNode } from "react";
import { FlexRow } from "ui-kit/Layout/Flex";
import { Typography } from "ui-kit/Typography";

const libraries = ["places", "drawing", "geometry"];

export const MapProvider = ({ children }: { children: ReactNode }) => {
  // Load the Google Maps JavaScript API asynchronously
  const { isLoaded: scriptLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string,
    libraries: libraries as Libraries,
  });

  if (loadError)
    return (
      <FlexRow justifyContent="center" alignItems="center" style={{ height: "100vh"}}>
          <Typography variant="body1">
            Oops, något gick fel när vi försökte ladda kartan.
          </Typography>
      </FlexRow>
    );

  if (!scriptLoaded)
    return (
      <FlexRow justifyContent="center" alignItems="center" style={{ height: "100vh"}}>
        <Typography variant="body1">Laddar kartan...</Typography>
      </FlexRow>
    );

  return <>{children}</>;
};

export default MapProvider;
